import { System } from './roles';

/**
 * 路由的定制化访问限制（在角色权限之外的额外限制，如仅某企业可见）
 *
 * 用法：在路由 meta.access 里写一个判断函数，返回 false 时不可访问
 *   meta: { access: isLincAgent }
 *   meta: { access: ({ enterpriseId }) => Number(enterpriseId) === 1000001 }
 * 路由守卫（直接访问 URL）和菜单生成都会校验，不满足时与「无该模块权限」的处理一致
 */

/** 判断所需的用户上下文，由调用方从 user store 取，保持本文件无 store 依赖 */
export interface RouteAccessContext {
  userSystem: string | null;
  enterpriseId: number | string | null;
}

export type RouteAccess = (ctx: RouteAccessContext) => boolean;

declare module 'vue-router' {
  interface RouteMeta {
    /** 定制化访问限制，见 src/router/config/route-access.ts */
    access?: RouteAccess;
  }
}

/** 株式会社 Linc 的企业 ID */
export const LINC_ENTERPRISE_ID = 1000019;

/** 猎头端的株式会社 Linc（路由限制和页面内的显隐判断共用） */
export const isLincAgent: RouteAccess = ({ userSystem, enterpriseId }) =>
  userSystem === System.agent && Number(enterpriseId) === LINC_ENTERPRISE_ID;

/** 是否满足路由 meta.access；未配置时视为满足 */
export function meetsRouteAccess(meta: { access?: RouteAccess } | undefined, ctx: RouteAccessContext): boolean {
  return meta?.access ? meta.access(ctx) : true;
}
